/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { OrdersBreakdown } from "@lemmonhq/types";
import { formatPriceInLocale } from "@lemmonhq/orders";
import { useLocalization } from "@lemmonhq/uikit";

export const OrderTypes = defineComponent<{
  data: OrdersBreakdown;
  totalAmount: number;
  currency: string;
}>({
  name: "OrderTypes",
  props: ["data", "totalAmount", "currency"],
  setup(props) {
    const showRevenue = ref(true);
    const { t } = useLocalization();
    return () => {
      const by_service = props.data.by_service_method || [];
      const totalCount = by_service.reduce((sum, d) => sum + d.total_count, 0);
      const totalAmount = by_service.reduce(
        (sum, d) => sum + d.total_revenue,
        0,
      );

      return (
        <div class="card transition-shadow border rounded-lg md:rounded-box">
          <div class="card-body p-4 md:p-6">
            <div class="flex justify-between items-center">
              <h3 class="card-title flex items-center gap-2 text-accent font-normal">
                <span class="material-symbols-outlined">category</span>
                {t("reports.dashboard.order_types")}
              </h3>
              <div class="join">
                <button
                  class={`join-item btn btn-sm ${
                    showRevenue.value ? "btn-active" : ""
                  }`}
                  onClick={() => (showRevenue.value = true)}
                >
                  <span class="material-symbols-outlined sm:hidden text-base">
                    payments
                  </span>
                  <span class="hidden sm:inline">
                    {t("reports.dashboard.revenue")}
                  </span>
                </button>
                <button
                  class={`join-item btn btn-sm ${
                    !showRevenue.value ? "btn-active" : ""
                  }`}
                  onClick={() => (showRevenue.value = false)}
                >
                  <span class="material-symbols-outlined sm:hidden text-base">
                    tag
                  </span>
                  <span class="hidden sm:inline">
                    {t("reports.dashboard.count")}
                  </span>
                </button>
              </div>
            </div>
            <div class="space-y-4 md:space-y-6 pt-4 md:pt-6">
              {by_service.map((type) => {
                const value = showRevenue.value
                  ? type.total_revenue
                  : type.total_count;
                const total = showRevenue.value ? totalAmount : totalCount;
                const percentage = (value / total) * 100;

                if (!type.service_method) {
                  console.log("no type", type);
                  return null;
                }

                return (
                  <div key={type.service_method} class="group">
                    <div class="flex justify-between mb-2">
                      <div class="flex items-center gap-2 text-accent">
                        <span class="material-symbols-outlined">
                          {type.service_method === "dine-in"
                            ? "restaurant"
                            : "takeout_dining"}
                        </span>
                        <span class="capitalize">
                          {type.service_method.replace("-", " ")}
                        </span>
                      </div>
                      <span class="font-normal text-accent">
                        {showRevenue.value
                          ? formatPriceInLocale(
                              type.total_revenue,
                              true,
                              2,
                              props.currency,
                            )
                          : type.total_count}
                      </span>
                    </div>
                    <div class="w-full h-2 bg-base-300 rounded-full overflow-hidden">
                      <div
                        class={`h-full transition-all group-hover:brightness-110 ${
                          type.service_method === "dine-in"
                            ? "bg-success"
                            : "bg-primary"
                        }`}
                        style={{ width: `${percentage}%` }}
                      />
                    </div>
                    <div class="flex justify-between mt-1">
                      <span class="text-sm opacity-60">
                        {percentage.toFixed(1)}% of{" "}
                        {showRevenue.value ? "total sales" : "total orders"}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      );
    };
  },
});
